// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-3Oh4GPL6","sider":"sider-GhmxI9ob","stock_box":"stock_box-2DFo6BeQ clearfix","sider_list":"sider_list-hBzoD7hc"};